/**
 * 회원 포털 전용 Supabase 쿼리
 */
import { supabase } from './supabase';
import { toCamel } from '../utils/helpers';

// 내 회원 레코드 조회 (members.user_id = auth.uid())
export async function getMyMemberRecord() {
  const { data: { user } } = await supabase.auth.getUser();
  const { data, error } = await supabase
    .from('members')
    .select('*')
    .eq('user_id', user?.id)
    .single();
  if (error) return null;
  return {
    ...toCamel(data),
    createdAt: data.created_at ? data.created_at.split('T')[0] : data.created_at,
  };
}

// 내 헬스장 정보
export async function getMyGym(gymId) {
  const { data, error } = await supabase
    .from('gyms')
    .select('*')
    .eq('id', gymId)
    .single();
  if (error) return null;
  return toCamel(data);
}

// 내 회원권 목록
export async function getMyMemberships(memberId) {
  const { data } = await supabase
    .from('memberships')
    .select('*')
    .eq('member_id', memberId)
    .order('created_at', { ascending: false });
  return (data || []).map(m => ({
    ...toCamel(m),
    days: m.duration_days,
  }));
}

// 내 락커 조회
export async function getMyLocker(memberId) {
  const { data } = await supabase
    .from('lockers')
    .select('*')
    .eq('member_id', memberId)
    .eq('status', 'occupied')
    .maybeSingle();
  return data ? toCamel(data) : null;
}

// 내 출석 목록
export async function getMyAttendances(memberId) {
  const { data } = await supabase
    .from('attendances')
    .select('*')
    .eq('member_id', memberId)
    .order('date', { ascending: false });
  return toCamel(data || []);
}

// 내 PT 부여 목록
export async function getMyPtAssignments(memberId) {
  const { data } = await supabase
    .from('pt_assignments')
    .select('*')
    .eq('member_id', memberId)
    .order('created_at', { ascending: false });
  return toCamel(data || []);
}

// 내 PT 일지 목록
export async function getMyPtLogs(memberId) {
  const { data } = await supabase
    .from('pt_logs')
    .select('*')
    .eq('member_id', memberId)
    .order('date', { ascending: false });
  return toCamel(data || []);
}

// 연장 신청 제출
export async function submitRenewalRequest(memberId, { productName, note } = {}) {
  const { error } = await supabase.rpc('submit_renewal_request', {
    p_member_id: memberId,
    p_product_name: productName || null,
    p_note: note || null,
  });
  return { error: error?.message || null };
}

// 정보 수정 신청 제출
export async function submitProfileEditRequest(memberId, { changes, note } = {}) {
  const { error } = await supabase.rpc('submit_profile_edit_request', {
    p_member_id: memberId,
    p_changes: changes,
    p_note: note || null,
  });
  return { error: error?.message || null };
}

// 내 정보 수정 신청 내역
export async function getMyProfileEditRequests(memberId) {
  const { data } = await supabase
    .from('profile_edit_requests')
    .select('*')
    .eq('member_id', memberId)
    .order('created_at', { ascending: false });
  return toCamel(data || []);
}

// 내 연장 신청 내역
export async function getMyRenewalRequests(memberId) {
  const { data } = await supabase
    .from('renewal_requests')
    .select('*')
    .eq('member_id', memberId)
    .order('created_at', { ascending: false });
  return toCamel(data || []);
}
